export type FilterItem = {
  id: number | null;
  name: string;
  field_type: FilterType;
  localized_name: string;
  dictionary_type?: string;
};

export type FilterList = FilterItem[];

export type FilterRow = {
  id: number;
  name: string;
  model: string;
  type: FilterType;
  dictionaryModel: string;
  localized_name: string;
};

export enum FilterType {
  Sku = 'sku',
  String = 'string',
  Status = 'status',
  Insight = 'insight',
  Boolean = 'boolean',
  Date = 'date',
  Number = 'number',
  Reference = 'reference',
  Select = 'select',
  User = 'user',
}

export type CreateFilterOptions = {
  showCheckboxForEmptyValue: boolean;
  showCheckboxForFilledValueForFilters: FilterType[];
  search?:
    | {
        searchFn?: () => FilterRow;
      }
    | true;
  cacheDictionary: boolean;
  rows: Array<{
    name: 'fields';
    fields: FilterList;
    excludeFields?: string[];
  }>;
};

export class FilterBean<Data = any> {
  model: string = '';
  name: string = '';
  localized_name: string = '';
  type: FilterType = FilterType.Boolean;
  is_null: boolean = false;
  not_null: boolean = false;
  dictionaryModel: string = '';
  value: (string | number | boolean)[] | string | null = null;
  from: string | number | null = null;
  to: string | number | null = null;
  isExactMatch: boolean = false;
  data?: Data;
  id?: number;

  constructor(type: FilterType, opts?: Partial<FilterBean>) {
    this.type = type;
    Object.assign(this, opts || {});
  }

  static getFilter(filter: FilterBean): Partial<FilterBean> {
    const { is_null, value, not_null, from, to, isExactMatch } = filter;
    switch (filter.type) {
      case FilterType.Date:
      case FilterType.Number:
        return { is_null, from, to, not_null };
      case FilterType.Sku:
        return { is_null, value, isExactMatch };
      default:
        return { is_null, value, not_null };
    }
  }
}

export type Filter<FT = FilterBean | string> = Record<string, FT>;

export type FilterQ<FQT = FilterBean | string> = { q: Filter<FQT> };
